import { z } from "zod";
/*
 * Tool-usage ranking evidence for a running turn's tool discovery. The tenant answers only while
 * the sending attempt holds the run, for the organisation the run belongs to.
 */
const id = z.string().trim().min(1).max(200);
export const workerToolUsageRequestSchema = z.object({
    runId: id, tenantSlug: id, workerId: id,
    attemptNumber: z.number().int().positive(),
    toolNames: z.array(z.string().trim().min(1).max(200)).min(1).max(1_000),
}).strict();
export const workerToolUsageResponseSchema = z.object({
    organisationId: id,
    /** Completed sessions in the last 30 days that used each tool successfully. */
    sessions: z.record(z.string(), z.number().int().nonnegative()),
}).strict();
export const WORKER_TOOL_USAGE_REFUSALS = {
    leaseNotHeld: "tool_usage_lease_not_held",
    organisationMissing: "tool_usage_organisation_missing",
};
